// hooks/useAudioPlayer.js
import { useRef, useState } from 'react';

export const useAudioPlayer = () => {
  const [currentAudio, setCurrentAudio] = useState(null);
  const audioRefs = useRef({});

  const handleAudioClick = (audioSrc) => {
    const audio = audioRefs.current[audioSrc];
    if (currentAudio === audio) {
      if (audio.paused) {
        audio.play();
      } else {
        audio.pause();
      }
    } else {
      if (currentAudio) {
        currentAudio.pause();
      }
      setCurrentAudio(audio);
      audio.play();
    }
  };

  const handleAudioPause = () => {
    // Optional: handle pause event
  };

  const registerAudioRef = (src, audioElement) => {
    if (audioElement) {
      audioRefs.current[src] = audioElement;
    }
  };

  return {
    currentAudio,
    audioRefs,
    handleAudioClick,
    handleAudioPause,
    registerAudioRef,
  };
};